<template>
  <div>
    <b-card>
      <div class="row-flex">
        <div>
          <label class="mr-3 bold">{{ $t('produto') }}</label>
          <b-form-select
            class="input-pentagro"
            name="productId"
            id="productId"
            v-model="data.productId"
            v-validate="{ required: true }"
            :disabled="greatnessInAnalysis.length > 0"
            :options="products"
            value-field="id"
            text-field="description"
            disabled-field="notEnabled"
          >
          </b-form-select>
        </div>
        <div>
          <label class="mr-3 mt-2 bold">{{ $t('processo-0') }}</label>
          <b-form-select
            class="input-pentagro"
            name="processId"
            id="processId"
            v-model="data.processId"
            v-validate="{ required: true }"
            :disabled="greatnessInAnalysis.length > 0"
            :options="process"
            value-field="id"
            text-field="description"
            disabled-field="notEnabled"
          >
          </b-form-select>
        </div>

        <span
          v-if="(equipments.length && greatness.length) || newData || editing"
        >
          <div>
            <b-table
              class="table mt-3"
              :items="equipments"
              :fields="fields"
              select-mode="multi"
              responsive="sm"
              ref="selectableTable"
              text-field="description"
              selectable
              @row-selected="onRowSelected"
            >
            </b-table>
            <div v-if="selectedEquipments.length > 0">
              <p class="mb-1">{{ $t('equipamentos-selecionados') }}</p>
              <div class="field-selected">
                <span
                  class="lines-selected"
                  v-for="(item, i) in selectedEquipments"
                  :key="i"
                >
                  {{ item.description }}
                  <strong
                    class="btn-clear"
                    title="$t('remover-selecao')"
                    @click="removeSelected(item)"
                    >x</strong
                  >
                </span>
              </div>
            </div>
          </div>

          <div class="mt-2">
            <label class="mr-3 bold">{{ $t('grandezas') }}</label>
            <div class="gridGreatness grid1 middle"></div>
          </div>
        </span>
        <span v-else><p>{{ $t('aguardando-dados') }}</p></span>
      </div>

      <b-row class="groupBtn mt-4">
        <img
          src="@/assets/salvar.png"
          :alt="$t('salvar')"
          style="margin-left: 20px"
          :title="$t('salvar')"
          @click="addGreatness"
        />
        <img
          id="closeModalPassword"
          class="float-right"
          src="@/assets/sair.png"
          style="margin-right: 15px; margin-left: 20px"
          :title="$t('sair')"
          :alt="$t('sair')"
          @click="$bvModal.hide('addingGreatness')"
        />
      </b-row>
    </b-card>
    <b-modal
      id="confirmDeleteOneData"
      ok-variant="danger"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      @ok="deleteGreatness(temp)"
      >{{ $t('deseja-excluir-a-s-grandeza-s') }}</b-modal
    >

    <b-modal
      id="DeletionOneNotAllowed"
      size="md"
      hide-footer
      :title="$t('alerta')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        :info="deletionNotAllowed"
        modelname="DeletionOneNotAllowed"
      />
    </b-modal>
  </div>
</template>

<script>
import { showError, defaultSuccess, urlMainAPI } from "@/global";
import axios from "axios";
import * as cGridAll from "vue-cheetah-grid";
import * as cheetahGrid from "cheetah-grid";
import { FiltersMixin } from "../mixins/filtersMixin";
import MessageBox from "@/components/template/MessageBoxModal.vue";

var greatnessData = [];
var inputEditor = new cheetahGrid.columns.action.InlineInputEditor();
var inputEditable = new cheetahGrid.columns.action.InlineInputEditor();
var buttomBin = new cheetahGrid.columns.action.ButtonAction({
  action(rec) {
    vue.temp = rec;
    vue.$bvModal.show("confirmDeleteOneData");
  },
});

buttomBin.disabled = (record) => {
  if (record.name && record.unit) 
    return false;
  return true;
};

inputEditor.disabled = (record) => {
  if (record.name != undefined) {
    let find = vue.greatnessInAnalysis.find(
      (x) => x.name.toUpperCase() === record.name.toUpperCase()
    );

    if (!find) return false;
    else return true;
  }
};

var vue;
let IsNumber = (num) => isNaN(parseFloat((num + "").replace(",", ".")))

const { CLICK_CELL, INPUT_CELL } = cheetahGrid.ListGrid.EVENT_TYPE;

export default {
  name: "FormGreatness",

  props: ["enviaSinal", "data", "newData"],

  inject: ["reloadGreatness"],

  components: { ...cGridAll, MessageBox },

  mixins: [FiltersMixin],

  data: function () {
    return {
      products: [],
      process: [],
      equipments: [],
      selectedEquipments: [],
      greatnessInAnalysis: [],
      rowSelected: {},
      copy: false,
      wasSaved: 0,
      callParent: 0,
      fields: [ { key: "description", label: this.$t('equipamentos-2') + ":"} ],
      greatness: [],
      temp: {},
      deletionNotAllowed: "",
      editing: false,

      currentLine: 0,
      productId: null,
      processId: null,
      equipmentId: null,
      header: [
        {
          field: "name",
          caption: this.$t('nome-0'),
          action: inputEditor,
          width: "35%",
          maxWidth: "40%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "eclipse" },
        },
        {
          field: "unit",
          caption: this.$t('unidade'),
          action: inputEditable,
          width: "23%",
          maxWidth: "30%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse", textAlign: "center" },
        },
        {
          field: "lowerThreshould",
          caption: "LIE",
          action: inputEditable,
          width: "18%",
          maxWidth: "26%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse", textAlign: "center" },
          message(rec){
            if(!rec.lowerThreshould)
              return null

            if(((IsNumber(rec.lowerThreshould) && rec.lowerThreshould != null) && rec.lowerThreshould != '' )){
              return 'Por favor, digite apenas número.'
            }
            if(rec.upperThreshould != null){
              if(parseFloat(rec.upperThreshould.toString().replace(",", ".")) < parseFloat(rec.lowerThreshould.toString().replace(",", "."))){
                return 'Por favor, LIE deve ser menor que LSE.'
              }
            }
            return null;
          }
        },
        {
          field: "upperThreshould",
          caption: "LSE",
          action: inputEditable,
          width: "18%",
          maxWidth: "26%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse", textAlign: "center" },
          message(rec){
            if(!rec.upperThreshould)
              return null

            if(((IsNumber(rec.upperThreshould) && rec.upperThreshould != null) && rec.upperThreshould != '' )){
              return 'Por favor, digite apenas número.'
            }
            if(parseFloat(rec.upperThreshould.toString().replace(",", ".")) < parseFloat(rec.lowerThreshould.toString().replace(",", "."))){
              return 'Por favor, LSE deve ser maior que LIE.'
            }
            return null;
          }
        },
        {
          width: "43px",
          minWidth: "43px",
          maxWidth: "43px",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse" },
          icon: {
            font: "normal normal normal 28px/1 FontAwesome",
            content: "\uf1f8",
            width: 28, // Optional
          },
          columnType: new cheetahGrid.columns.type.ButtonColumn({
            caption: "",
          }),
          action: buttomBin
        },
      ],
    };
  },

  watch: {
    callParent() {
      defaultSuccess(this.$t('grandeza-configurada-e-salva-com-sucesso'));
      this.reloadGreatness();
      this.$bvModal.hide("addingGreatness");
    },
  },

  methods: {
    async loadProducts() {
      const url = `${urlMainAPI}/getproducts`;
      await axios
        .get(url)
        .then((res) => {
          this.products =
            res.data.length == 0 ? [{ description: "" }] : res.data;
          this.products.unshift({
            id: null,
            description: this.$t('selecione-um-produto-0'),
          });
        })
        .catch(console.log);
    },

    async loadProcess() {
      const url = `${urlMainAPI}/getprocess`;
      await axios
        .get(url)
        .then((res) => {
          this.process =
            res.data.length == 0 ? [{ description: "" }] : res.data;
          this.process.unshift({
            id: null,
            description: this.$t('selecione-um-processo-0'),
          });
        })
        .catch(console.log);
    },

    async loadEquipments() {
      const url = `${urlMainAPI}/getequipments`;
      await axios
        .get(url)
        .then((res) => {
          this.equipments = !res.data.length ? [{ description: "" }] : res.data;
        })
        .catch(console.log);
    },

    createGrid() {
      const grid = new cheetahGrid.ListGrid({
        parentElement: document.querySelector(".gridGreatness"),
        allowRangePaste: true,
        header: this.header,
      });

      grid.records = this.greatness;

      grid.listen(INPUT_CELL, (...args) => {
        if (
          args[0].row == this.greatness.length &&
          !this.greatness[this.greatness.length - 1].name
        ) {
          this.setGrid();
        }
      });

      grid.listen(CLICK_CELL, (...args) => {
        this.currentLine = args[0].row;
        let hasData = this.greatness[this.greatness.length - 1].name
          ? this.greatness[this.greatness.length - 1].name.trim()
            ? true
            : false
          : false;

        if (args[0].row == this.greatness.length && hasData) {
          this.setGrid();
        }
      });

      this.setGrid = function (table = this.greatness) {
        this.addLine();
        grid.records = table;
      };
    },

    clearEmptyLines() {
      let count = this.greatness.length - this.currentLine + 1;
      for (let i = 0; i < count; i++) this.greatness.pop();
    },

    addLine(param) {
      this.greatness.push({
        productId: "",
        equipmentId: "",
        processId: "",
        name: param,
        unit: "",
        lowerThreshould: null,
        upperThreshould: null,
      });
    },

    copyEquipments() {
      this.copy = !this.copy;
    },

    addGreatness() {
      const url = `${urlMainAPI}/savegreatness`;

      let countGreatness = this.greatness.length - 2;
      let countEquipments = this.selectedEquipments.length - 1;

      this.greatness.forEach((element, iGreatness) => {
        this.selectedEquipments.forEach((equi, iEquipments) => {
          if (element.name !== undefined) {
            let saveGreatness = {
              productId: this.data.productId,
              equipmentId: equi.id,
              processId: this.data.processId,
              name: element.name,
              unit: element.unit,
              lowerThreshould:
                element.lowerThreshould && element.lowerThreshould != "-" ?
                  parseFloat(element.lowerThreshould.toString().replace(",", ".")):
                  -9999, 
              upperThreshould:
                element.upperThreshould && element.upperThreshould != "-" ? 
                parseFloat(element.upperThreshould.toString().replace(",", ".")):
                -9999,
            };


            if (saveGreatness.productId == null){
              showError(this.$t('produto-precisa-ser-selecionado'));
              return
            }
            else if (saveGreatness.processId == null){
              showError(this.$t('processo-precisa-ser-selecionado'));
              return
            }
            else if (this.selectedEquipments.length == 0){
              showError(this.$t('equipamento-precisa-ser-selecionado'));
              return
            }
            else if (saveGreatness.name === ""){
              showError(this.$t('grandeza-precisa-de-um-nome'));
              return
            }
            else if (isNaN(saveGreatness.lowerThreshould)){
              showError(saveGreatness.name + this.$t('nao-salvo-o-valor-do-limite-inferior-invalido'));
              return
            }
            else if (isNaN(saveGreatness.upperThreshould)){
              showError(saveGreatness.name + this.$t('nao-salvo-o-valor-do-limite-superior-invalido'));
              return
            }
            else if (saveGreatness.lowerThreshould == -9999 && saveGreatness.upperThreshould == -9999){
              showError(saveGreatness.name + this.$t('nao-salvo-deve-se-inserir-ao-menos-um-limite'));
              return
            }
            else if (parseFloat(saveGreatness.upperThreshould) < parseFloat(saveGreatness.lowerThreshould)){
              showError(saveGreatness.name + this.$t('nao-salvo-o-lse-deve-ser-maior-que-lie'));
              return
            }
            else {
              defaultSuccess(this.$t('salvando-dados'))
              axios
                .post(url, saveGreatness)
                .then(() => {
                  if (
                    iGreatness == countGreatness &&
                    iEquipments == countEquipments
                  )
                    this.callParent++;
                    defaultSuccess(this.$t('grandeza-s-configurada-s-com-sucesso'))
                })
                .catch();
            }
          }
        });
      });
    },

    onRowSelected(items) {
      this.selectedEquipments = items;
    },

    canSave(){
      let hasError = false;
      this.json.forEach(w => {
        if(parseFloat(w.upperThreshould) > parseFloat(w.lowerThreshould))
          hasError = true

        if((isNaN(parseFloat(w.upperThreshould)) && w.upperThreshould != null) && w.upperThreshould != '')
          hasError = true
          
        if((isNaN(parseFloat(w.lowerThreshould)) && w.lowerThreshould != null) && w.lowerThreshould != '')
          hasError = true

      })
      return hasError;
    },

    removeSelected(item) {
      if (this.selectedEquipments.length > 1) {
        let index = this.equipments.indexOf(item);
        this.$refs.selectableTable.unselectRow(index);
      }
    },

    async transformGreatness() {
      if (this.data.productId != null) {
        const url = `${urlMainAPI}/getgreatness/${this.data.productId}/${this.data.processId}/${this.data.equipmentId}`;
        await axios.get(url).then(async (res) => {
          this.greatness = res.data;
          greatnessData = JSON.parse(JSON.stringify(res.data));
          let equipment = await this.equipments.find(
            (e) => e.id == this.data.equipmentId
          );

          this.greatness.forEach((element) => {
            element.lowerThreshould =
              element.lowerThreshould == -9999 ? "-" : element.lowerThreshould;
            element.upperThreshould =
              element.upperThreshould == -9999 ? "-" : element.upperThreshould;
          });

          let index = this.equipments.indexOf(equipment);
          this.$refs.selectableTable.selectRow(index);
        });
      }
    },

    canDeleteData(greatness) {
      let g = greatnessData.find((g) => g.name == greatness.name);
      if (!(g && g.name) && greatness.name){
        this.greatness = this.greatness.filter(g => g.name != greatness.name)
        this.greatness.pop();
        this.setGrid();
        return true
      }
      return false;
    },

    deleteGreatness(greatness) {
      if (this.canDeleteData(greatness)) return

      const url = `${urlMainAPI}/deleteonegreatness`;
      if (!greatness.name) showError(this.$t('nao-e-possivel-remover-uma-linha-vazia'));
      else {
        if(greatness.lowerThreshould == "-")
          greatness.lowerThreshould = -9999
        if(greatness.upperThreshould == "-")
          greatness.upperThreshould = -9999
        axios.post(url, greatness).then(async (res) => {
          let greatnessDelete = res.data;
          if (greatnessDelete.deleted == false) {
            let text = `A grandeza ${greatnessDelete.greatnessDelete.name} não pôde ser removida pois possui análise(s) lançada(s).`;
            this.deletionNotAllowed = text;
            this.$bvModal.show("DeletionOneNotAllowed");
          } else {
            defaultSuccess(this.$t('grandeza-removida-com-sucesso'));
          }
          await this.transformGreatness();
          this.setGrid();
          this.$bvModal.hide("confirmDeleteOneData");
          this.editing = true;
        });
      }
    },

    greatnessCanNotDelete() {
      if (!this.newData) {
        const url = `${urlMainAPI}/getgreatnessinanalysis/${this.data.productId}/${this.data.processId}/${this.data.equipmentId}`;

        axios.get(url).then((res) => {
          this.greatnessInAnalysis = res.data;
        });
      }
    },
  },

  created() {
    vue = this;
  },

  async mounted() {
    await this.loadProducts();
    await this.loadProcess();
    await this.loadEquipments();
    await this.transformGreatness();
    this.greatnessCanNotDelete();
    this.createGrid();
    this.setGrid();
  },
};
</script>

<style scoped>
.grid1 {
  height: calc(63vh - 220px);
  width: 100%;
  border: solid 1px rgba(0, 0, 0, 0.26);
  overflow-x: hidden;
  overflow-y: auto;
}

.row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
  /* margin-right: 70px; */
}

.group {
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}

.gridBtGroup {
  margin: 30px auto auto auto;
  width: 80vw;
  display: flex;
  justify-content: flex-end;
}

.ybase {
  /* margin-right: 20px; */
  margin-top: 20x;
}

.gridBtGroup img {
  cursor: pointer;
  max-height: 45px;
}

.bold {
  font-weight: bold;
}

.table,
.indicator-select,
.fault-tree {
  max-height: 155px;
  overflow-x: auto;
  border: 1px solid #00000013;
  border-radius: 4px;
  box-shadow: 2px 2px 2px #00000013;
}

.fault-tree {
  overflow-x: none;
  max-height: 600px;
  padding: 10px;
}

.indicator-select {
  margin-bottom: 15px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

img,
.copy {
  cursor: pointer;
  max-height: 35px;
}

.copy {
  height: 35px;
  width: 35px;
  color: #ff7100;
  transition-delay: 600ms;
}

.field-selected {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 15px;
  max-height: 100px;
  overflow-y: auto;
}

.lines-selected {
  background-color: #00000013;
  padding: 0 3px;
  margin: 2px 5px;
  border-radius: 3px;
}

.btn-clear {
  cursor: pointer;
}

</style>